import { Module } from '../../utils';
import reducers from './reducers';

export default new Module({
  reducers
});

export * from './components';
export * from './providers';
